<template>
    <div :class="getFieldClass" v-if="clone">
        <label v-if="!!label" :class="'field-name'" :for="getInputId(0)">{{label}}</label>
        <div v-for="(val, index) in value" :key="index" class="duplicate-box" :class="value.length>1 ? 'can-remove' : ''">
            <input-field :value="val"
                         :type="type"
                         :options="options"
                         :id="getInputId(index)"
                         @input="inputHandler($event,index)"
                         @focus="focusHandler(index)"
                         @blur="blurHandler"
                         @invalid="errorHandler($event,index)"
                         @enter="handleEnter"
            ></input-field>
            <p :class="error[index] ? 'field-error' : 'field-hint'">{{error[index] ? error[index] : hint}}</p>
            <span v-show="value.length>1" @click="deleteField(index)" title="Удалить" class="js-remove-field">
                <icon-base width="12" height="12" viewBox="0 0 14 14"><icon-close/></icon-base>
            </span>
        </div>
        <span class="js-add-field" @click="addField">
            <span>Добавить</span>
            <icon-base width="20" height="20" viewBox="0 0 20 20"><icon-add/></icon-base>
        </span>
    </div>
    <div :class="getFieldClass" v-else>
        <label v-if="!!label" :class="'field-name'" :for="getInputId(0)">{{label}}</label>
        <input-field :value="value"
                     :type="type"
                     :options="options"
                     :id="getInputId(0)"
                     @input="inputHandler($event)"
                     @focus="focusHandler"
                     @blur="blurHandler"
                     @enter="handleEnter($event)"
                     @invalid="errorHandler($event)"
        ></input-field>
        <p :class="error || isError ? 'field-error' : 'field-hint'">{{error ? error : hint}}</p>
    </div>
</template>

<script>
    import InputField from "./InputField";
    import {GROUP} from "../../../constants/common"
    import IconBase from "../IconBase";
    import IconClose from "../icons/IconClose";
    import IconAdd from "../icons/IconAdd";

    export default {
        name: 'field-wrapper',
        components: {
            IconAdd,
            IconClose,
            IconBase,
            InputField,
        },
        props: {
            id: [Number, String],
            type: String,
            label: String,
            value: undefined,
            required: {
                type: Boolean,
                default: false
            },
            options: Object,
            clone: {
                type: Boolean,
                default: false
            },
            hint: String,
            isError: Boolean
        },
        data () {
            return {
                focus: false,
                error: false
            }
        },
        computed: {
            getFieldClass() {
                let cssClass = 'field';
                cssClass += this.focus ? ' on-focus' : '';
                cssClass += this.required ? ' required' : '';
                cssClass += !this.$_.isEmpty(this.error) ? ' error-field' : '';
                return cssClass;
            },
        },
        methods: {
            getInputId(index) {
                let id = 'inp-' + this.id;
                if (this.clone) {
                    id = id + '-' + index;
                }
                return id
            },
            getFocus () {
                return this.clone ? !!this.value[0] : !!this.value;
            },
            inputHandler(e, index) {
                let newValue = this.value;
                if (this.clone) {
                    newValue.splice(index, 1, e);
                } else {
                    newValue = e;
                }
                this.$emit('input', newValue)
            },
            focusHandler(index) {
                this.focus = true;
                if (this.clone) {
                    this.error.splice(index, 1, false)
                } else {
                    this.error = false
                }
            },
            blurHandler() {
                this.focus = this.getFocus()
            },
            handleEnter() {
                this.$emit('enter')
            },
            addField() {
                let newValue = this.value;
                if (this.type === GROUP) {
                    newValue.push({values: []});
                } else {
                    newValue.push('');

                }

                this.$emit('input', newValue)
            },
            deleteField(index) {
                let newValue = this.value;
                newValue.splice(index, 1);
                this.$emit('input', newValue)
            },
            errorHandler(message, index) {
                if (this.clone) {
                    this.error.splice(index, 1, message);
                } else {
                    this.error = message;
                }
            }
        },
        created() {
            if(this.clone && !(this.value instanceof Array)) {
                this.$emit('input', [this.value]);
            }

            if(this.clone) {
                this.error = new Array(this.value.length);
            }

            if (this.type === GROUP) {
                this.error = false
            }
        },
        mounted() {
            this.focus = this.getFocus();
        },
        updated ()
        {
            this.focus = this.focus || this.getFocus()
        }

    }
</script>


<style scoped>

</style>
